var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "EmdFormGroup",
    {
      attrs: {
        label: _vm.$t("recipients.create.description"),
        state: _vm.getState(_vm.$v.recipient.description),
        feedbacks: _vm.feedbacks(_vm.$v.recipient.description),
      },
    },
    [
      _c("EmdInput", {
        attrs: {
          name: "description",
          readonly: _vm.disabled,
          disabled: _vm.disabled,
        },
        on: { input: () => _vm.$v.recipient.description.$touch() },
        model: {
          value: _vm.recipient.description,
          callback: function ($$v) {
            _vm.$set(_vm.recipient, "description", $$v)
          },
          expression: "recipient.description",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }